import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { DebounceInput } from 'react-debounce-input';

import StyledNotes from './StyledNotes';

import { selectMatch } from 'features/match/matchSlice';
import { isQuotaExceededError } from '../../helpers/isQuotaExceeded';
import ls from 'localstorage-slim';
import { LOCAL_STORAGE_TTL } from '../../constants/localStorage';

const Notes: React.FC = () => {
  const match = useSelector(selectMatch);
  const [notes, setNotes] = useState('');

  const key = `${match.id}.notes`;

  useEffect(() => {
    const storedNotes = ls.get(key) as string;
    setNotes(storedNotes);
  }, [key]);

  const save = (value: string) => {
    try {
      ls.set(key, value, { ttl: LOCAL_STORAGE_TTL });
    } catch (e) {
      console.log('Error in local storage', e);
      if (isQuotaExceededError(e)) {
        ls.flush();
      }
    }
  };

  const handleChange = (event: any) => {
    const { value } = event.target;

    setNotes(value);
    save(value);
  };

  return (
    <StyledNotes>
      <div className="tabs">
        <div className="tab active">
          <FormattedMessage id="notes.title" />
        </div>
      </div>
      <div className="content">
        <DebounceInput
          value={notes ? notes : ''}
          minLength={2}
          debounceTimeout={300}
          onChange={handleChange}
          element="textarea"
        />
      </div>
    </StyledNotes>
  );
};

export default Notes;
